module.exports = "https://web-assets-production.autolist.com/_next/static/images/manufacturer-logos-sprite-448345976f538b2e3e0037fd493f4f38.png";